import React from 'react'

import {
  ArrowRight, Button, Icon, SuccessFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, shape, string,
} from 'prop-types'

import { PLAN_CHANGE_TIMING, PLAN_TYPE, TIER } from '../../../constants'
import { planChangeTargetShape } from '../../../propTypes'

const KEY = 'subscription_management.plan_change'
const BADGE_ICON_SIZE = { width: '16', height: '16' }
const ARROW_SIZE = { width: '16', height: '16' }

function actionLabel(translate, card, planName) {
  if (card.current) {
    const toAnnual = card.action.billingTerm === PLAN_TYPE.ANNUAL
    return translate(`${KEY}.actions.${toAnnual ? 'switch_to_annual' : 'switch_to_monthly'}`)
  }
  const verb = card.action.timing === PLAN_CHANGE_TIMING.IMMEDIATE ? 'upgrade' : 'downgrade'
  return translate(`${KEY}.actions.${verb}${card.showAnnualPrice ? '_annual' : ''}`, { plan: planName })
}

function CardAction({
  card, planName, upgradeUrl, effectiveDate = null, onSelect: handleSelect, translate,
}) {
  if (!card.action) {
    return card.current && (
      <p className="cgt-caption-semibold plan-change-modal__best-value">
        <Icon
          svgComponent={SuccessFilled}
          size={BADGE_ICON_SIZE}
          className="plan-change-modal__success-icon"
          notSpaced
        />
        {translate(`${KEY}.best_value`)}
      </p>
    )
  }

  const isImmediate = card.action.timing === PLAN_CHANGE_TIMING.IMMEDIATE
  const isPrimary = isImmediate && !card.current && card.tier === TIER.PREMIUM
  const label = actionLabel(translate, card, planName)

  return (
    <div className="plan-change-modal__action">
      {isImmediate ? (
        <Button
          type={isPrimary ? 'primary' : 'secondary'}
          href={`${upgradeUrl}?target=${card.action.target}`}
          customClass="plan-change-modal__action-button"
          trailIcon={<Icon svgComponent={ArrowRight} size={ARROW_SIZE} notSpaced />}
        >
          {label}
        </Button>
      ) : (
        <Button
          type="secondary"
          actionType="button"
          customClass="plan-change-modal__action-button"
          onClick={() => handleSelect(card.action)}
        >
          {label}
        </Button>
      )}
      <p className="cgt-caption plan-change-modal__action-note">
        {isImmediate ? translate(`${KEY}.starts_today`) : translate(`${KEY}.takes_effect`, { date: effectiveDate })}
      </p>
    </div>
  )
}

CardAction.propTypes = {
  card: shape({
    tier: string.isRequired,
    current: bool.isRequired,
    showAnnualPrice: bool.isRequired,
    action: planChangeTargetShape,
  }).isRequired,
  planName: string.isRequired,
  upgradeUrl: string.isRequired,
  effectiveDate: string,
  onSelect: func.isRequired,
  translate: func.isRequired,
}

export default CardAction
